<template>
  <div class="widget-item" :id="widget.object.wid" :style="style">
    <TrafiklabViewer
      :viewerStyles="widget.object.viewerStyles"
      :timetable="widget.object.timetable"
      :appId="widget.object.wid"
      :name="widget.object.name"
      alt="Trafiklab app"
    />
  </div>
</template>

<script>
  import TrafiklabViewer from '@/components/common/timetable/TrafiklabViewer.vue';

  import templateWidget from '@/components/templates/mixins/templateWidget';
  import { simpleTypeMixin } from '@/helpers';

  export default {
    name: 'TrafiklabWidget',

    components: { TrafiklabViewer },

    mixins: [simpleTypeMixin, templateWidget],

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    computed: {
      style() {
        return {
          ...this.defaultStyling(this.widget),
          overflow: 'hidden',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widget-item {
    position: absolute;
    overflow: hidden;
  }
</style>
